import React from 'react';
import Styles from '../ClubSpecs.module.scss';

const IronSpec = (props) => {
  const { clubItem, getFormattedDate } = props;
  const { attributes } = clubItem;

  return (
    <>
      {clubItem?.enterDate && (
        <div className={Styles.specItem}>
          BUILD DATE:
          <span className={Styles.specValue}>
            {getFormattedDate(new Date(clubItem.enterDate))}
          </span>
        </div>
      )}
      {attributes?.dexterity && (
        <div className={Styles.specItem}>
          DEXTERITY:
          <span className={Styles.specValue}>{attributes.dexterity}</span>
        </div>
      )}
      {attributes?.loft && (
        <div className={Styles.specItem}>
          LOFT:
          <span className={Styles.specValue}>{attributes.loft}</span>
        </div>
      )}
      {attributes?.advancedloft && (
        <div className={Styles.specItem}>
          ADVANCED LOFT:
          <span className={Styles.specValue}>{attributes.advancedloft}</span>
        </div>
      )}
      {attributes?.hosel && (
        <div className={Styles.specItem}>
          HOSEL CODE:
          <span className={Styles.specValue}>{attributes.hosel}</span>
        </div>
      )}
      {attributes?.colorcode && (
        <div className={Styles.specItem}>
          COLOR CODE:
          <span className={Styles.specValue}>
            {/* <div className={Styles.colorCodeIcon}></div> */}
            {attributes.colorcode}
          </span>
        </div>
      )}
      {attributes?.advancedlie && (
        <div className={Styles.specItem}>
          ADVANCED LIE:
          <span className={Styles.specValue}>{attributes.advancedlie}</span>
        </div>
      )}
      {attributes?.headtype && (
        <div className={Styles.specItem}>
          HEAD TYPE:
          <span className={Styles.specValue}>{attributes.headtype}</span>
        </div>
      )}
      {attributes?.swingweight && (
        <div className={Styles.specItem}>
          SWING WEIGHT:
          <span className={Styles.specValue}>{attributes.swingweight}</span>
        </div>
      )}
      {attributes?.requestedswingweight && (
        <div className={Styles.specItem}>
          REQUESTED SWING WEIGHT:
          <span className={Styles.specValue}>
            {attributes.requestedswingweight}
          </span>
        </div>
      )}
      {attributes?.shaft && (
        <div className={Styles.specItem}>
          SHAFT:
          <span className={Styles.specValue}>{attributes.shaft}</span>
        </div>
      )}
      {attributes?.shaftmaterial && (
        <div className={Styles.specItem}>
          SHAFT MATERIAL:
          <span className={Styles.specValue}>{attributes.shaftmaterial}</span>
        </div>
      )}
      {attributes?.length && (
        <div className={Styles.specItem}>
          LENGTH:
          <span className={Styles.specValue}>{attributes.length}</span>
        </div>
      )}
      {attributes?.grip && (
        <div className={Styles.specItem}>
          GRIP:
          <span className={Styles.specValue}>{attributes.grip}</span>
        </div>
      )}
      {attributes?.gripsize && (
        <div className={Styles.specItem}>
          GRIP SIZE:
          <span className={Styles.specValue}>{attributes.gripsize}</span>
        </div>
      )}
      {attributes?.etch && (
        <div className={Styles.specItem}>
          ETCH:
          <span className={Styles.specValue}>{attributes.etch}</span>
        </div>
      )}
      {attributes?.etchfont && (
        <div className={Styles.specItem}>
          ETCH FONT:
          <span className={Styles.specValue}>{attributes.etchfont}</span>
        </div>
      )}
      {attributes?.etchtype && (
        <div className={Styles.specItem}>
          ETCH TYPE:
          <span className={Styles.specValue}>{attributes.etchtype}</span>
        </div>
      )}
    </>
  );
};

export default IronSpec;
